import * as z from "zod";

const GoogleShoppingListingMediaSchema_ = z.object({
  googleMediaId: z.string().nullable(),
  imageUrl: z.string(),
  position: z.number(),
});
export const GoogleShoppingListingMediaSchema: z.ZodType<GoogleShoppingListingMedia> =
  GoogleShoppingListingMediaSchema_;
export interface GoogleShoppingListingMedia
  extends z.infer<typeof GoogleShoppingListingMediaSchema_> {}

export type GoogleShoppingListingMediaWithoutRedoIds = Omit<
  GoogleShoppingListingMedia,
  "id"
>;

export type GoogleShoppingListingMediaWithGoogleIds = Omit<
  GoogleShoppingListingMedia,
  "googleMediaId"
> & { googleMediaId: string };
